import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map, Observable } from 'rxjs';
import { Products } from '../models/products.models';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(
    private http:HttpClient
  ) { }

  getProducts():Observable<Products>{
    const url:string = `${environment.apiUrl}/stripe/products`;
    return this.http.get<Products>(url)
  }
}
